import { cn } from "@/lib/cn.js";

const map: Record<string, string> = {
  OK: "badge-success",
  ACTIVE: "badge-success",
  APPROVED: "badge-success",
  DONE: "badge-success",
  SUCCESS: "badge-success",
  WARN: "badge-warn",
  PENDING: "badge-warn",
  PAUSED: "badge-warn",
  SCHEDULED: "badge-warn",
  QUEUED: "badge-warn",
  RUNNING: "badge-info",
  PARTIAL: "badge-info",
  SENT: "badge-info",
  DRAFT: "badge-neutral",
  FINISHED: "badge-neutral",
  UNKNOWN: "badge-neutral",
  DISABLED: "badge-neutral",
  CANCELLED: "badge-neutral",
  INVITED: "badge-info",
  SUSPENDED: "badge-warn",
  DOWN: "badge-danger",
  REJECTED: "badge-danger",
  FAILED: "badge-danger",
  FAILURE: "badge-danger",
};

export function StatusBadge({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="badge-neutral">—</span>;
  return <span className={cn(map[value] ?? "badge-neutral")}>{value}</span>;
}
